import type { NewSimulationFormProps } from './types'

export const initialFormValues: NewSimulationFormProps = {
  simulationType: '',
  nome: '',
  cargo: '',
  dataInicioAdmissao: '',
  salarioAdmissao: '',
  semJustaCausa: false
}
